import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InquiryBidMultiList(props) {
  const Config = {
    purchase: {
      apiPath: '/bidding/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/inquiry/bid-multi/detail',
      searchBarPlaceholder: '竞价编号/标题',
      tabs: ['全部', '待竞价', '竞价中', '比价中'],
      countApi: '/bidding/count',
      countApiParams: {
        biddingOrderType: 2
      },
      arrEnumField: [
        { mainKey: 'B02_Bid_Status', subKey: 'status', value: 'statusName' }
      ],
      countTransform: (data, self) => {
        //分类统计 [1待竞价, 3竞价中, 4比价中]
        let { 1: a, 2: b, 4: c } = data;
        setCount([undefined, a, b, c]);
      },
      tabConfig: [
        undefined, //全部
        [1], // 待竞价
        [2], //竞价中
        [4] //比价中
      ]
    },
    sale: {
      apiPath: '/cbidding/pageMultiProducts',
      enumMainKey: 'B02_Bid_Confirm_Flag',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/inquiry/bid-multi/detail',
      searchBarPlaceholder: '竞价编号/标题',
      tabs: ['全部', '待竞价', '竞价中', '待发布结果'],
      countApi: '/cbidding/count',
      countApiParams: {
        biddingOrderType: 2
      },
      arrEnumField: [
        { mainKey: 'B02_Bid_Status', subKey: 'status', value: 'statusName' }
      ],
      countTransform: (data, self) => {
        //分类统计 [1待竞价, 3竞价中, 4待发布结果]
        let { 1: a, 2: b, 4: c } = data;
        setCount([undefined, a, b, c]);
      },
      tabConfig: [
        undefined, //全部
        [1], // 待竞价
        [2], //竞价中
        [4] //待发布结果
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab],
      orderStatus: undefined,
      biddingOrderType: self.isPurchase ? 2 : undefined
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.bidXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.bidXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'B02_Bid_Status',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>竞价项目标题</label>
                          <div className="blue">{item.billTitle}</div>
                        </li>
                        {self.isPurchase && (
                          <li>
                            <label>是否公开</label>
                            <div>
                              {item.biddingRangeType === 2 ? '公开' : '不公开'}
                            </div>
                          </li>
                        )}
                        <li>
                          <label>发布时间</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>有效竞价时间</label>
                          <div>
                            {formatDate(item.bidStartDate, 'YYYY-MM-DD HH:mm')}{' '}
                            - {formatDate(item.bidEndDate, 'YYYY-MM-DD HH:mm')}
                          </div>
                        </li>

                        {!self.isPurchase ? (
                          <li>
                            <label>竞价物料项</label>
                            <div>{item.productCount}</div>
                          </li>
                        ) : (
                          <li>
                            <label>收到邀约报价</label>
                            <div>
                              {item.qouteVendorCount}&nbsp;/&nbsp;
                              {item.vendorCount}
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>已报价项次</label>
                            <div>{item.productQuoteCount}</div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>非最低价项</label>
                            <div>{item.unMinPriceCount}</div>
                          </li>
                        )}
                        {item.confirmBiddingFlagName && (
                          <li>
                            <label>竞价确认</label>
                            <div
                              className={
                                item.confirmBiddingFlag === 1
                                  ? 'green'
                                  : item.confirmBiddingFlag === 2
                                  ? 'red'
                                  : ''
                              }
                            >
                              {item.confirmBiddingFlagName}
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>竞价结果</label>
                            <div>
                              <span
                                className={
                                  'u-sign ' +
                                  (item.quoteSelectedFlag === 0
                                    ? 'orange'
                                    : 'green')
                                }
                              >
                                {item.quoteSelectedFlag === 2
                                  ? '全部入选'
                                  : item.quoteSelectedFlag === 1
                                  ? '部分入选'
                                  : item.quoteSelectedFlag === 0
                                  ? '未入选'
                                  : ''}
                              </span>
                            </div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InquiryBidMultiList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InquiryBidMultiList);
